import * as yup from 'yup'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const singleTimePayoutSearchValidationSchema = (): any => {
  return yup.object().shape({
    phone: yup.string().max(11),
  })
}
